import React from 'react';
import Podcast from './Podcast';
import blog_image from './blog-post-thumb-1.jpg';

function Main(props) {
  var podcasts = props.podcasts.map(podcast => <Podcast name={podcast.title} upvotes={podcast.upvotes} desc={podcast.desc} />);

  return (
    <div class="main-wrapper">
	    <section class="cta-section theme-bg-light py-5">
		    <div class="container text-center">
			    <h2 class="heading">Featured Podcasts</h2>
			    <div class="intro">INSERT DATE HERE</div>
			    <form class="signup-form form-inline justify-content-center pt-3">
          </form>
		    </div>
	    </section>

	    <section class="blog-list px-3 py-5 p-md-5">
		    <div class="container">
				    { podcasts }
		    </div>
	    </section>

	    <footer class="footer text-center py-2 theme-bg-dark">
          <small class="copyright">Designed with <i class="fas fa-heart"></i> by <a href="http://themes.3rdwavemedia.com" target="_blank">Podcast Hunt</a> for audio enthusiasts!</small>
	    </footer>

    </div>
  );
}

export default Main;
